import { Platform, NativeModules } from "react-native";
import { SupportedLanguage } from "./SupportedLanguage";

export function getSystemLanguage(): SupportedLanguage {
  try {
    const getLanguage = (locale: string) => {
      if (locale === "hr" || locale.startsWith("hr_"))
        return SupportedLanguage.HR;
      return SupportedLanguage.EN;
    };

    if (Platform.OS === "ios") {
      const locale: string =
        NativeModules.SettingsManager.settings.AppleLocale ??
        NativeModules.SettingsManager.settings.AppleLanguages[0];
      return getLanguage(locale);
    }

    if (Platform.OS === "android") {
      const identifier = NativeModules.I18nManager.localeIdentifier;
      return getLanguage(identifier);
    }

    return SupportedLanguage.EN;
  } catch {
    return SupportedLanguage.EN;
  }
}
